import React, { HTMLAttributes, HTMLProps, createRef } from 'react';
import Immutable from 'immutable';

import {
  WysiwygField,
} from '@uncinc/uncinc-react-kitchen-sink';

import { Badge, Tooltip } from '../../../components';
import useClasses from '../../../hooks/useClasses';
import { ImmutableBadgeTaxonomyEntity } from '..';

import './style.scss';

interface Props extends HTMLProps<HTMLAttributes<HTMLDivElement>> {
  entity: ImmutableBadgeTaxonomyEntity;
  achieved: boolean;
}

const TaxonomyBadge: React.FC<Props> = ({ entity, achieved, className }) => {
  const ref = createRef<HTMLDivElement>();
  const { buildClass, joinClasses } = useClasses('TaxonomyBadge');

  const name = entity.getIn(['name', 0, 'value'], '');
  const description = entity.getIn(['description', 0, 'processed'], '');
  const image = entity.getIn(['field_image', 0, 'entity', 'field_media_file', 0], Immutable.Map());

  return (
    <li className={joinClasses(buildClass(), className, { achieved })}>
      <Badge image={image} className={buildClass('image')} />

      <Tooltip targetRef={ref}>
        <strong>{name}</strong>
        <WysiwygField
          property="schema:text"
          html={description}
        />
      </Tooltip>
    </li>
  );
};

export default TaxonomyBadge;
